<template>
  <tab-navigation :tabs="tabs" :current-tab="currentTab" @change-tab="changeTab">
    <template #right-content></template>
  </tab-navigation>

  <main>
    <div class="layout-spacing">
      <component :is="currentTabComponent" :socialAuths="socialAuths" :loading="loading"/>
    </div>
  </main>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAssetStore } from '@/stores/asset'
import postList from './components/posts/index.vue'
import newContent from './components/posts/components/postCreator/index.vue'
import TabNavigation from '@/components/base/navigation/TabNavigation.vue'
import { useSocialMediaTabs } from './composables'

const assetStore = useAssetStore()

// Use the social media tabs composable
const tabsManager = useSocialMediaTabs({
  defaultTab: 'posts',
  components: {
    posts: postList,
    newContent: newContent
  }
})

// Destructure values from the composable
const { 
  currentTab, 
  tabs, 
  currentTabComponent, 
  socialAuths, 
  loading, 
  changeTab, 
  checkAuth, 
  checkPendingIntegration, 
  updateCurrentTab 
} = tabsManager

onMounted(async () => {
  // Logging removed
  await checkAuth(assetStore.assetId)
  checkPendingIntegration()
  updateCurrentTab()
})
</script>
